<template>
  <div transition="fade" v-if="components.length">
    <div
      class="overlay"
      v-for="modal in components"
      :key="modal.props.componentId"
    >
      <transition name="fade">
        <div class="modal" @click="closeComponent">
          <div
            class="modal-dialog modal-lg"
            :class="{
              'modal-dialog-full': modal.props.fullScreen,
              'modal-dialog-middle': modal.props.middle
            }"
          >
            <div
              class="modal-content"
              @click.stop
              :class="{ ' modal-content-full': modal.props.fullScreen }"
            >
              <component :is="modal.component" v-bind="modal.props" />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { newPopup, closePopup, messageBus, closeAllPopup } from "./MessageBus";

export default {
  name: "PopupContainer",
  data() {
    return {
      components: []
    };
  },
  methods: {
    addComponent(payload) {
      this.components.push(payload);
    },
    closeComponent() {
      this.components.pop();
    }
  },
  mounted() {
    messageBus.$on(newPopup, payload => {
      console.log(payload);
      this.addComponent(payload);
    });
    messageBus.$on(closePopup, () => {
      this.closeComponent();
    });
    messageBus.$on(closeAllPopup, () => {
      while (this.components.length > 0) {
        this.closeComponent();
      }
    });
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.modal {
  display: inline;
  z-index: 1006;
}

/* .fade-enter,
.fade-leave-to {
  opacity: 0;
} */

.blur {
  filter: blur(1px);
  opacity: 0.4;
}
.overlay {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1005; /* Specify a stack order in case you're using a different order for other elements */
  /* cursor: pointer; Add a pointer on hover */
}

.modal-dialog-full {
  width: 100%;
  height: 100%;
  padding: 0;
  min-width: 100%;
  min-height: 100%;
  margin: 0;
}

.modal-content-full {
  height: 100%;
  border-radius: 0;
}

.modal-dialog-middle {
  max-width: 90% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PopupContainer.vue